 
import { Amplify } from "aws-amplify";
import type { ResourcesConfig } from "aws-amplify";

const origin = globalThis.window?.location.origin || "";

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_OAUTH_DOMAIN,
          scopes: ["profile", "email", "openid"],
          redirectSignIn: [`${origin}${import.meta.env.VITE_REDIRECT_SIGN_IN}`],
          redirectSignOut: [
            `${origin}${import.meta.env.VITE_REDIRECT_SIGN_OUT}`,
          ],
          responseType: "code" as const,
        },
      },
    },
  },
};

export const libraryOptions = {
  Storage: {
    S3: {
      prefixResolver: async () => {
        return "";
      },
    },
  },
};

/**
 * Configura AWS Amplify con la configuración obtenida
 */
export const configureAmplify = () => {
  Amplify.configure(amplifyConfig, libraryOptions);
};

export default amplifyConfig;
